import { FC, useCallback } from "react";
import {
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import { DateDataPointNullable } from "../../../../../../../../../services/cloudchipr.api";
import { capitalizeString } from "../../../../../../../../../utils/helpers/capitalizeString";

interface WidgetFrequencySelectProps {
  frequency: DateDataPointNullable;
  onChange(value: SelectChangeEvent<DateDataPointNullable>): void;
  disabled?: boolean;
}
export const WidgetFrequencySelect: FC<WidgetFrequencySelectProps> = ({
  frequency,
  onChange,
  disabled,
}) => {
  const renderValue = useCallback((value: DateDataPointNullable) => {
    if (!value) {
      return;
    }
    return capitalizeString(value);
  }, []);
  return (
    <Tooltip
      arrow
      placement="right"
      title={
        disabled
          ? "The chart granularity is not applicable for this chart type."
          : ""
      }
    >
      <div>
        <Select
          size="small"
          fullWidth
          value={frequency}
          disabled={disabled}
          onChange={onChange}
          renderValue={renderValue}
        >
          <MenuItem value="monthly">
            <ListItemText>Monthly</ListItemText>
          </MenuItem>

          <MenuItem value="weekly">
            <ListItemText>Weekly</ListItemText>
          </MenuItem>

          <MenuItem value="daily">
            <ListItemText>Daily</ListItemText>
          </MenuItem>
        </Select>
      </div>
    </Tooltip>
  );
};
